var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 27,
    viewBox: "0 0 28 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 5.86938,
    y: 14.5833,
    width: 2.16667,
    height: 15.75,
    rx: 1,
    transform: "rotate(-90 5.86938 14.5833)",
    fill: "#80808F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9489 19.2339C12.5095 19.657 12.5095 20.3429 12.9489 20.766C13.3882 21.189 14.1005 21.189 14.5399 20.766L21.2899 14.266C21.7158 13.8558 21.7307 13.1954 21.3237 12.7679L15.1362 6.26789C14.7163 5.82684 14.0047 5.79705 13.5467 6.20134C13.0887 6.60563 13.0577 7.29091 13.4776 7.73196L18.9372 13.4673L12.9489 19.2339Z",
    fill: "#80808F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.ac6d1d798fbf27c42dad77d906befd2a.svg";
export { ForwardRef as ReactComponent };